import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import Moment from 'moment';
import Flatpickr from 'flatpickr'; // Add more locales here

import { Mandarin as zh } from 'flatpickr/dist/l10n/zh';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import 'flatpickr/dist/plugins/monthSelect/style.css'; // material ui component

import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { wireValue } from './hoc/prop-wire';
import ih from './utils/input-helper';
import { flatpickrToMomentToken } from './utils/date';
import Popover from './popover';
import { SIMPLE_VALUE_PROP } from './consts/prop-types';
var DATE_TIME_SUFFIX = {
  daySuffix: /(st)|(nd)|(rd)|(th)/g,
  timeSuffix: /(AM)|(PM)/gi
};
/**
 * A React DatePicker Component, containing validating the input date<br>
 * Uses [flatpickr]{@link https://chmln.github.io/flatpickr/#options}
 *
 * @constructor
 * @param {string} [id] - Container element #id
 * @param {string} [className] - Classname for the container
 * @param {string} [defaultValue] - Default selected date
 * @param {string} [value] - Current selected date
 * @param {object} [valueLink] - Link to update value. Used in conjuction with [linked-state-mixins]{@link module:linked-state-mixins}
 * @param {*} valueLink.value - value to update
 * @param {function} valueLink.requestChange - function to request value change
 * @param {boolean} [allowKeyIn=true] - Allow user key in to the from/to input?
 * @param {boolean} [disabled=false] - Is this field disabled?
 * @param {boolean} [readOnly=false] - Is this field readonly?
 * @param {boolean} [required=false] - Is this field required?
 * @param {function} [onChange] - Callback function when date is changed. <br> Required when value prop is supplied
 * @param {string} onChange.value - current value
 * @param {object} onChange.eventInfo - event related info
 * @param {object} onChange.eventInfo.before - previously enetered value
 * @param {string} [dateFormat='Y-m-d'] - Date format. See Flatpickr {@link https://chmln.github.io/flatpickr/#options}
 * @param {string} [timeFormat='H:i'] - Time format. See Flatpickr {@link https://chmln.github.io/flatpickr/#options}
 * @param {boolean} [enableTime=false] - Enable selection and display of time
 * @param {boolean} [enableAMPM=false] - Enable AM/PM option on calendar
 * @param {string} [locale] - Datepicker locale. Values can be 'en', 'zh', etc. See Flatpickr {@link https://chmln.github.io/flatpickr/#options}
 * @param {fuction} [t] - Transform/translate error into readable message.<br>
 * @param {object} t.params - Parameters relevant to the error code
 * @param {string} t.params.field - offending field id
 * @param {string} t.params.value - offending field value
 * @param {string} t.params.pattern - pattern the value was supposed to follow
 *
 * @example
// controlled

import {DatePicker} from 'react-ui'

React.createClass({
    getInitialState() {
        return {
            date: '2017-03-20',
            datetime: '2017-03-20 16:01'
        }
    },
    handleChange(field, value) {
        this.setState({[field]: value})
    },
    render() {
        let {date, datetime} = this.state;
        return <div className='c-form'>
            <div>
                <label htmlFor='date'>Select Date</label>
                <DatePicker id='date'
                    onChange={this.handleChange.bind(this,'date')}
                    value={date}
                    t={(code, params) => {
                        if (code === 'missing')
                            return `Please input date`
                        else {
                            return `Invalid date format. Should be ${params.pattern}`
                        }
                    }}/>
            </div>
            <div>
                <label htmlFor='datetime'>Select Date Time</label>
                <DatePicker id='datetime'
                    onChange={this.handleChange.bind(this,'datetime')}
                    enableTime={true}
                    value={datetime}
                    t={(code, params) => {
                        if (code === 'missing')
                            return `Please input date`
                        else {
                            return `Invalid date format. Should be ${params.pattern}`
                        }
                    }}/>
            </div>
        </div>
    }
})
 */

var DatePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "generateErrorMsg", function (dateStr) {
      var _this$props = _this.props,
          id = _this$props.id,
          enableTime = _this$props.enableTime,
          required = _this$props.required,
          t = _this$props.t;
      var datePattern = _this.FORMAT.date;
      var timePattern = _this.FORMAT.time.indexOf('A') !== -1 ? _this.FORMAT.time.replace('A', 'AM/PM') : _this.FORMAT.time;
      var pattern = enableTime ? "".concat(datePattern, " ").concat(timePattern) : datePattern;
      return ih.validateField(dateStr, {
        name: id,
        type: 'date',
        required: required,
        pattern: pattern
      }, t ? {
        et: t
      } : true);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (evt) {
      Popover.close();
      var newDate = evt.target.value;

      var isValid = _this.validateDateFormat(newDate);

      var prevDate = _this.state.prevDate;
      var required = _this.props.required;

      if (isValid) {
        // Prevent requiring double-click when select date
        if (newDate !== prevDate) {
          _this.datePicker.setDate(newDate);

          _this.setState({
            prevDate: newDate
          });
        }
      } else {
        // Reset to previous valid value
        if (required) {
          _this.datePicker.setDate(prevDate);
        } else {
          _this.datePicker.setDate('');

          _this.handleChange();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var onChange = _this.props.onChange;
      onChange(_this.date.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (evt) {
      var required = _this.props.required;
      var newDate = evt.target.value; // Remove the day suffix since Date can't resolve it

      var parseDate = _this.strToTimestamp(newDate);

      var isValid = _this.validateDateFormat(newDate);

      var errMsg = _this.generateErrorMsg(newDate);

      if (!isNaN(parseDate)) {
        // Move the calendar view to the current value's location
        _this.datePicker.jumpToDate(parseDate);

        if (isValid) {
          Popover.close(); // setDate() accepts date string & Date object
          // If set the 2nd parameter as true, it will recursively call itself here

          _this.datePicker.setDate(parseDate, false);

          _this.handleChange();
        } else {
          Popover.open(evt, /*#__PURE__*/React.createElement("span", null, errMsg), {
            pointy: true
          });
        }
      } else if (required || newDate !== '') {
        Popover.open(evt, /*#__PURE__*/React.createElement("span", null, errMsg), {
          pointy: true
        });
      } else {
        Popover.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "strToTimestamp", function (str) {
      var enableTime = _this.props.enableTime;
      var parsedStr = str.replace(DATE_TIME_SUFFIX.daySuffix, '');
      var momentFormat = enableTime ? "".concat(_this.FORMAT.date, " ").concat(_this.FORMAT.time) : _this.FORMAT.date;
      return Moment(parsedStr, momentFormat).valueOf();
    });

    _defineProperty(_assertThisInitialized(_this), "validateDateFormat", function (dateStr) {
      var enableTime = _this.props.enableTime;
      var isValid = false;

      if (enableTime) {
        isValid = Moment(dateStr, "".concat(_this.FORMAT.date, " ").concat(_this.FORMAT.time), true).isValid(); // Momentjs validation accepts single (a|A|p|P) for AM/PM
        // This is for ensuring user input complete 'AM/PM' term when AM/PM is enabled

        if (_this.FORMAT.time.indexOf('A') !== -1 && dateStr.search(DATE_TIME_SUFFIX.timeSuffix) === -1) {
          isValid = false;
        }
      } else {
        isValid = Moment(dateStr, "".concat(_this.FORMAT.date), true).isValid();
      }

      return isValid;
    });

    var value = props.value;
    _this.state = {
      prevDate: value
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props2 = this.props,
          dateFormat = _this$props2.dateFormat,
          timeFormat = _this$props2.timeFormat,
          enableTime = _this$props2.enableTime,
          enableAMPM = _this$props2.enableAMPM,
          allowInput = _this$props2.allowKeyIn,
          locale = _this$props2.locale,
          immediatelyOpen = _this$props2.immediatelyOpen,
          _onClose = _this$props2.onClose,
          enableSeconds = _this$props2.enableSeconds,
          onlyYearMonth = _this$props2.onlyYearMonth;
      var loc = null;

      switch (locale) {
        case 'zh':
          loc = zh;
          break;

        default:
          loc = null;
      }

      this.FORMAT = flatpickrToMomentToken(dateFormat, timeFormat, enableTime);
      var plugins = [];

      if (onlyYearMonth) {
        dateFormat = 'Y-m';
        plugins.push(new monthSelectPlugin({
          shorthand: true,
          dateFormat: "Y-m",
          altFormat: "Y年m月"
        }));
      } else if (enableTime) {
        dateFormat = "".concat(dateFormat, " ").concat(timeFormat);
      }

      this.datePicker = new Flatpickr(this.date, {
        enableTime: enableTime,
        allowInput: allowInput,
        dateFormat: dateFormat,
        enableSeconds: enableSeconds,
        locale: loc,
        time_24hr: !enableAMPM,
        minuteIncrement: 1,
        plugins: plugins,
        onChange: function onChange() {
          _this2.handleChange();
        },
        onClose: function onClose() {
          if (_onClose) _onClose();
        }
      });
      if (immediatelyOpen) this.date.focus();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.datePicker.destroy();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var value = nextProps.value,
          locale = nextProps.locale;
      var loc = null;

      switch (locale) {
        case 'zh':
          loc = zh;
          break;

        default:
          loc = null;
      }

      if (typeof value === 'string') {
        this.datePicker.set('locale', loc);
        this.datePicker.setDate(this.strToTimestamp(value), false);
      }

      this.setState({
        prevDate: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          id = _this$props3.id,
          value = _this$props3.value,
          style = _this$props3.style,
          className = _this$props3.className,
          readOnly = _this$props3.readOnly,
          disabled = _this$props3.disabled,
          required = _this$props3.required,
          allowKeyIn = _this$props3.allowKeyIn,
          name = _this$props3.name,
          autoComplete = _this$props3.autoComplete;
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: cx('c-date-picker', className),
        style: style
      }, /*#__PURE__*/React.createElement(TextField, {
        id: id,
        name: name,
        type: "text",
        inputRef: function inputRef(ref) {
          _this3.date = ref;
        },
        error: !value && required,
        disabled: disabled,
        readOnly: readOnly,
        required: required,
        onChange: allowKeyIn ? this.handleInputChange : null,
        onBlur: this.handleBlur,
        defaultValue: value,
        autoComplete: autoComplete,
        variant: "outlined",
        size: "small",
        InputProps: {
          endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
            position: "end"
          }, /*#__PURE__*/React.createElement(DateRangeIcon, {
            className: "date-range-icon",
            onClick: function onClick() {
              _this3.date.focus();
            }
          }))
        }
      }));
    }
  }]);

  return DatePicker;
}(React.Component);

_defineProperty(DatePicker, "defaultProps", {
  dateFormat: 'Y-m-d',
  timeFormat: 'H:i',
  disabled: false,
  readOnly: false,
  required: false,
  allowKeyIn: true,
  enableTime: false,
  enableSeconds: false,
  enableAMPM: false,
  locale: 'en',
  autoComplete: 'off',
  name: '',
  immediatelyOpen: false,
  onlyYearMonth: false
});

_defineProperty(DatePicker, "propTypes", {
  id: PropTypes.string,
  className: PropTypes.string,
  value: SIMPLE_VALUE_PROP,
  allowKeyIn: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  dateFormat: PropTypes.string,
  timeFormat: PropTypes.string,
  enableTime: PropTypes.bool,
  enableSeconds: PropTypes.bool,
  enableAMPM: PropTypes.bool,
  locale: PropTypes.string,
  autoComplete: PropTypes.string,
  name: PropTypes.string,
  t: PropTypes.func,
  immediatelyOpen: PropTypes.string,
  onlyYearMonth: PropTypes.bool
});

export default wireValue(DatePicker);